import { Address } from '../Model/address';

export abstract class AutocompleteService {
    abstract getAutoCompleteAddresses(input: string): Promise<Address[]>;
}
